import { ToothSurface } from '../../../../graphql/graphql';

export const SURFACES_TRANSLATION_MAP = {
	[ToothSurface.CervicalBuccal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.cervicalBuccal',
	[ToothSurface.Buccal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.buccal',
	[ToothSurface.Mesial]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.mesial',
	[ToothSurface.Incisal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.incisal',
	[ToothSurface.Occlusal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.occlusal',
	[ToothSurface.Distal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.distal',
	[ToothSurface.Palatal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.palatal',
	[ToothSurface.CervicalPalatal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.cervicalPalatal',
	[ToothSurface.MesioBuccalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.mesioBuccalCusp',
	[ToothSurface.DistoBuccalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.distoBuccalCusp',
	[ToothSurface.MesioPalatalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.mesioPalatalCusp',
	[ToothSurface.DistoPalatalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.distoPalatalCusp',
	[ToothSurface.MesioLingualCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.mesioLingualCusp',
	[ToothSurface.DistoLingualCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.distoLingualCusp',
	[ToothSurface.PalatalSurface]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.palatalSurface',
	[ToothSurface.BuccalSurface]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.buccalSurface',
	[ToothSurface.LingualSurface]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.lingualSurface',
	[ToothSurface.Class_4Mesial]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.class4Mesial',
	[ToothSurface.Class_4Distal]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.class4Distal',
	[ToothSurface.Lingual]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.lingual',
	[ToothSurface.CervicalLingual]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.cervicalLingual',
	[ToothSurface.BuccalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.buccalCusp',
	[ToothSurface.PalatalCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.palatalCusp',
	[ToothSurface.LingualCusp]:
		'patientTreatment.meddiDENT.dentalCross.surfaces.lingualCusp',
	[ToothSurface.BuccalRestoration]: '',
	[ToothSurface.Crown]: '',
};
